import { ChangeDetectionStrategy, Component, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IgxGridComponent, SortingDirection } from '@infragistics/igniteui-angular';

import { BaseSubResource, dataToken } from '../../../core/abstractions/base.sub-resource';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { ShareholderAccountModel } from '../../../models/shareholder-account.model';

@Component({
    selector: 'sl-shareholder-accounts',
    templateUrl: './shareholder-accounts.component.html',
    styleUrls: ['./shareholder-accounts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShareholderAccountsComponent extends BaseSubResource implements OnInit {
    @ViewChild('grid', { static: true }) grid: IgxGridComponent;

    accounts: ShareholderAccountModel[] = [];
    isFromTraders = false;

    private readonly componentData = inject<ApiResponseModel<ShareholderAccountModel[]>>(dataToken);
    private readonly activatedRoute = inject(ActivatedRoute);

    constructor() {
        super();
        this.accounts = this.componentData.value;
    }

    ngOnInit(): void {
        this.grid.sortingExpressions = [{ fieldName: 'numberOfShares', dir: SortingDirection.Desc }];
        this.activatedRoute.snapshot.pathFromRoot.forEach(p => {
            if (!!p.url[0] && p.url[0].path.includes('traders')) {
                this.isFromTraders = true;
                return;
            }
        });
    }
}
